import styled from 'styled-components';

export const LabelWrapper = styled.div`
  flex: 1;
  margin: 0 8px;
  font-size: 0.9rem;
`;

export const Container = styled.a<{ $iconPosition: 'left' | 'right' }>`
  background-color: transparent;
  border: 0;
  outline: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 3px;
  padding: ${({ $iconPosition }) =>
    $iconPosition === 'left' ? '8px 0 8px 8px' : '8px 8px 8px 0'};
  text-decoration: none;
  color: #000;

  &:hover {
    text-decoration: underline;
  }

  & > ${LabelWrapper} {
    order: ${({ $iconPosition }) => ($iconPosition === 'left' ? 1 : 0)};
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const IconContainer = styled.a`
  background-color: transparent;
  border: 0;
  outline: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: background-color 0.3s ease;
  border-radius: 3px;
  padding: 8px;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

export const IconWrapper = styled.div`
  display: flex;

  > svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: ${({ theme }) => theme.colors.lightBlue};
  }
`;
